module.exports = __webpack_public_path__ + "img/pic_an_xzh@2x(1).5b2fb4ab.png";